export default __webpack_public_path__ + "static/media/prometheus.fc02d75f.svg";